"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPrimitive = exports.objectKeys = exports.objectValues = void 0;
/** Helpers */
// helper to get an array containing the object values with
// the correct type infered.
// eslint-disable-next-line @typescript-eslint/ban-types
function objectValues(obj) {
    return Object.keys(obj).map(function (objKey) { return obj[objKey]; });
}
exports.objectValues = objectValues;
// eslint-disable-next-line @typescript-eslint/ban-types
function objectKeys(obj) {
    return Object.keys(obj).map(function (objKey) { return objKey; });
}
exports.objectKeys = objectKeys;
// Type guard for the primitive types which will support printing
// out of the box
function isPrimitive(value) {
    return (typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean" ||
        typeof value === "symbol");
}
exports.isPrimitive = isPrimitive;
